import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiLinux,
  SiVisualstudiocode,
  SiInsomnia,
  SiIntellijidea,
  SiGit,
  SiGithub,
  SiKubernetes,
  SiHelm,
  SiDocker,
  SiAzuredevops,
  SiJenkins
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* Container & Orchestration */}
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiKubernetes />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Kubernetes</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiDocker />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Docker</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiHelm />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Helm</div>
      </Col>
      
      {/* CI/CD & GitOps */}
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiAzuredevops />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Azure DevOps</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiJenkins />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Jenkins</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiGit />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Git</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiGithub />
        <div style={{fontSize: "12px", marginTop: "5px"}}>GitHub</div>
      </Col>
      
      {/* Development Tools */}
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiIntellijidea />
        <div style={{fontSize: "12px", marginTop: "5px"}}>IntelliJ IDEA</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiVisualstudiocode />
        <div style={{fontSize: "12px", marginTop: "5px"}}>VS Code</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiInsomnia/>
        <div style={{fontSize: "12px", marginTop: "5px"}}>Insomnia</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiLinux />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Linux</div>
      </Col>
    </Row>
  );
}

export default Toolstack;
